import React, { Fragment } from 'react'
import { BRow, BCol, BTitle, BText } from '@prague-digi/ui-components'
import { compose } from 'redux'
import { FormattedMessage } from 'react-intl'
import { connect, ConnectedProps } from 'react-redux'

import phoneRingImg from '@prague-digi/ui-styles/src/images/nwp-icon/phone-ring.svg'
import { intl, wizard, IntlInterface } from '../../hoc'
import messages from '../../i18n'
import { isoToCzDate, isoToCzTime } from '../../utils/dates'
import noSmileImg from '../../assets/noSmile.svg'
import styles from './styles.scss'
import { ReduxImmutableState } from '../../types'
import { SUPPORT_PHONE } from '../../constants'

type Props = IntlInterface & ConnectedProps<typeof connector>

export const Availability = ({ translate, availability }: Props) => (
  <Fragment>
    <div className={styles.imageWrapper}>
      <img alt="phone" src={noSmileImg} />
    </div>
    <BTitle type="h3" center>
      {translate(messages.availability.text)}
      <br />{' '}
      {availability?.outageEnd && (
        <FormattedMessage
          {...messages.availability.time}
          values={{
            application: (
              <BText component="span" type="info">
                {translate(messages.basicLayout.pageTitle)}
              </BText>
            ),
            day: (
              <BText component="span" type="info">
                {isoToCzDate(availability.outageEnd)}
              </BText>
            ),
            time: (
              <BText component="span" type="info">
                {isoToCzTime(availability.outageEnd)}
              </BText>
            ),
          }}
        />
      )}
    </BTitle>

    <div className={styles.delimiter} />

    <div className={styles.actionsContainer}>
      <BRow>
        <BCol xs="12" sm="6" theme="offset-sm-3">
          <div className={styles.actionBox}>
            <img alt="phone" src={phoneRingImg} />
            <BText center type="notice" theme={styles.callUs}>
              {translate(messages.errors.scoring.callUs)}
            </BText>
            <BText center type="primary" theme={styles.supportPhone}>
              {SUPPORT_PHONE}
            </BText>
          </div>
        </BCol>
      </BRow>
    </div>
  </Fragment>
)

const connector = connect((state: ReduxImmutableState) => ({
  availability: state.app.availability,
}))

export default compose(intl, wizard, connector)(Availability)
